import React from 'react';
import PropTypes from 'prop-types';
import { intlShape } from 'react-intl';
import { defaultLocaleData } from 'dynamic-data/supported-locales.constants';
import { get as getSupportedLocales } from 'dynamic-data/supported-locales';
import { ga } from 'helpers/multitrack';
import { segment } from 'helpers/segment';
import { DisclosureArrow } from 'components/DisclosureArrow/DisclosureArrow';

export class LocaleSwitcher extends React.Component {
  constructor() {
    super();
    this.localeClicked = this.localeClicked.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
  }

  onCloseModal() {
    const currentLocale = this.getCurrentLocale();
    segment.track('Click - Close Locale Modal', {
      category: 'Footer',
      label: currentLocale,
    });
    ga('Footer', 'Click - Close Locale Modal', currentLocale);
    this.props.hideModal('LocaleModal');
  }

  getCurrentLocale() {
    const {
      intl: { locale: currentLocale },
    } = this.props;

    return currentLocale;
  }

  localeClicked() {
    const currentLocale = this.getCurrentLocale();
    this.props.showModal('LocaleModal', {
      currentLocale,
      locales: getSupportedLocales(),
      onModalClose: this.onCloseModal,
      onSelect: this.props.updateAccountLocale,
    });
    segment.track('Click - Current Locale', {
      category: 'Footer',
      label: currentLocale,
    });
    ga('Footer', 'Click - Current Locale', currentLocale);
  }

  render() {
    const { className, children } = this.props;

    const locales = getSupportedLocales();
    const currentLocale = this.getCurrentLocale();

    // NOTE: The default locale scenario is dependent on the 'supported_languages_web' flag being enabled
    // The case where we fallback to our default locale is if the user's locale is set to a locale
    // that we have translated files for BUT aren't returning from babelfish as a supported locale
    const currentLocaleData = locales.find(locale => locale.localeKey === currentLocale) || defaultLocaleData;

    return (
      <span className={className}>
        {children({
          name: currentLocaleData.languageName,
          locale: currentLocale,
          onClick: this.localeClicked,
        })}
      </span>
    );
  }
}

LocaleSwitcher.defaultProps = {
  className: 'LocaleSwitcher',
  children: ({
    /* eslint-disable react/prop-types */
    locale,
    onClick,
    name,
    /* eslint-enable */
  }) => (
    <a key={locale} onClick={onClick}>
      {name}
      <DisclosureArrow className="LocaleSwitcher__arrow" svgClassName="LocaleSwitcher__arrow__svg" />
    </a>
  ),
};

LocaleSwitcher.propTypes = {
  intl: intlShape.isRequired,
  className: PropTypes.string,
  children: PropTypes.func,
  hideModal: PropTypes.func,
  showModal: PropTypes.func,
  updateAccountLocale: PropTypes.func.isRequired,
};
